<template>
  <div class="flex min-h-screen">
    <!-- Left: repeating background (hidden on mobile) -->
    <div
      class="hidden min-h-screen flex-[0_0_40%] bg-gray-100 bg-[url('/images/login-bg-pattern.webp')] bg-[length:750px_auto] bg-right bg-repeat md:block"
      aria-hidden="true"
    />

    <!-- Right: yellow panel with login content -->
    <div
      class="flex min-h-screen flex-1 items-center justify-center bg-[#F9BE00] p-8"
    >
      <div
        class="flex w-full max-w-[360px] flex-col items-center text-center"
      >
        <a
          :href="config.websiteUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="mb-10 block"
        >
          <img
            src="/images/phottr-logo.svg"
            alt="Phottr"
            class="h-24 w-[150px]"
          />
        </a>

        <h1 class="mb-2 !text-[35px] font-semibold text-black">
          Sign in to Cloud
        </h1>
        <p class="mb-12 text-lg text-black">
          Sign in with your Phottr account to continue
        </p>

        <div class="flex w-full flex-col items-center gap-3">
          <button
            type="button"
            class="inline-flex w-full max-w-[280px] cursor-pointer items-center justify-center gap-3 rounded-full border-0 bg-black py-3.5 px-5 text-base font-medium text-white transition-colors hover:bg-[#1a1a1a] active:opacity-90"
            @click="signInWithGoogle"
          >
            <img
              src="/images/google-logo.svg"
              alt=""
              class="h-5 w-5 shrink-0"
            />
            <span>Continue with Google</span>
          </button>
          <button
            type="button"
            class="inline-flex w-full max-w-[280px] cursor-pointer items-center justify-center gap-3 rounded-full border-0 bg-black py-3.5 px-5 text-base font-medium text-white transition-colors hover:bg-[#1a1a1a] active:opacity-90"
            @click="signInWithApple"
          >
            <img
              src="/images/apple-logo.svg"
              alt=""
              class="h-5 w-5 shrink-0"
            />
            <span>Continue with Apple</span>
          </button>
        </div>

        <p class="mt-4 text-sm text-black">
          By sign in, you agree to our
          <a
            :href="config.termsUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="text-black underline"
          >
            Terms
          </a>
          and
          <a
            :href="config.privacyPolicyUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="text-black underline"
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { config } from '@/config';
import { useAuth } from './auth';

const { signInWithApple, signInWithGoogle } = useAuth();
</script>
